import { Component, OnInit } from '@angular/core';
import { PermissionsEnum } from 'src/app/models/role.model';
import { DashboardConfiguration } from 'src/app/models/utility.model';
import { AuthService } from 'src/app/services/auth.service';
import { IdleService } from 'src/app/services/idle.service';
import { SidebarService } from 'src/app/services/sidebar.service';

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.scss']
})
export class PrivateLayoutComponent implements OnInit {
  isSidebarExpanded = true;
  usePadding = false;
  PermissionsEnum = PermissionsEnum;
  DashboardConfiguration = DashboardConfiguration;

  constructor(private sidebarService: SidebarService, public idleService: IdleService, public authService: AuthService) {
    this.sidebarService.isSidebarExpanded$.subscribe((state) => {
      this.isSidebarExpanded = state;
    });

    
   }

  ngOnInit(): void {
    this.idleService.startWatching();
  }

}
